import { connect } from 'react-redux'

import { getUser } from '../../common/actions/user/'
import {
  initUserSearchResultsViewType,
  getUserVideoPlayerStatus
} from '../../common/actions/user/preference'
import {
  toggleOffCanvas,
  closeModal
} from '../../common/actions/layout'

const mapStateToProps = (state) => {
  const { layout, common, searchPage, user, marketing } = state
  const { pageIsOffCanvas, pageCanvasDirection, isModalOpen, openModalType, openModalData } = layout
  const { ingestedContent } = searchPage
  const { banners } = marketing

  return {
    user: user,
    pageIsOffCanvas,
    pageCanvasDirection,
    isModalOpen,
    openModalType,
    openModalData,
    stats: common.stats,
    currentSite: common.currentSite,
    baseUrl: common.baseUrl,
    menuConfig: common.menuConfig,
    errorPage: common.errorPage,
    noIndex: common.noIndex,
    seoMeta: common.seoMeta,
    ingestedContent,
    banners
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    initUser: () => {
      dispatch(initUserSearchResultsViewType(ownProps.location))
      dispatch(getUserVideoPlayerStatus())
      dispatch(getUser())
    },
    toggleOffCanvas: (direction) => {
      dispatch(toggleOffCanvas(direction))
    },
    closeModal: () => dispatch(closeModal())
  }
}

const createAppContainer = (component) => {
  return connect(mapStateToProps, mapDispatchToProps)(component)
}

export default createAppContainer



// WEBPACK FOOTER //
// ./client/containers/appContainer.js